export const USER_GOOGLE_TOKEN_SUCCESS = "USER_GOOGLE_TOKEN_SUCCESS";
// User Signup & Login Details
export const USER_INFO_REQUEST = "USER_INFO_REQUEST";
export const USER_INFO_SUCCESS = "USER_INFO_SUCCESS";
export const USER_INFO_FAIL = "USER_INFO_FAIL";
export const USER_OTP_REQUEST = "USER_OTP_REQUEST";
export const USER_OTP_SUCCESS = "USER_OTP_SUCCESS";
export const USER_OTP_FAIL = "USER_INFO_FAIL";
export const USER_LOGOUT = "USER_LOGOUT";
// User Subscribe Details
export const USER_SUBSCRIBE_REQUEST = "USER_INFO_REQUEST";
export const USER_SUBSCRIBE_SUCCESS = "USER_INFO_SUCCESS";
export const USER_SUBSCRIBE_FAIL = "USER_INFO_FAIL";
// User Tutorial Popup Model
export const SKIP_MODEL_REQUEST = "SKIP_MODEL_REQUEST";
export const SKIP_MODEL_SUCCESS = "SKIP_MODEL_SUCCESS";
export const SKIP_MODEL_FAIL = "SKIP_MODEL_FAIL";
// Dashboard get All projects
export const PROJECTS_REQUEST = "PROJECTS_REQUEST";
export const PROJECTS_SUCCESS = "PROJECTS_SUCCESS";
export const PROJECTS_APPEND_SUCCESS = "PROJECTS_APPEND_SUCCESS";
export const PROJECTS_FAIL = "PROJECTS_FAIL";
// Project Rename
export const RENAME_PROJECT_REQUEST = "RENAME_PROJECT_REQUEST";
export const RENAME_PROJECT_SUCCESS = "RENAME_PROJECT_SUCCESS";
export const RENAME_PROJECT_FAIL = "RENAME_PROJECT_FAIL";
// Templates
export const TEMPLATE_REQUEST = "TEMPLATE_REQUEST";
export const TEMPLATE_SUCCESS = "TEMPLATE_SUCCESS";
export const TEMPLATE_FAIL = "TEMPLATE_FAIL";
// Project Layout (Navbar / Sidebar / Preview / Options / Footer)
export const PROJECT_CREATE_GOOGLE_SUCCESS = "PROJECT_CREATE_GOOGLE_SUCCESS";
export const PROJECT_CREATE_REQUEST = "PROJECT_CREATE_REQUEST";
export const PROJECT_CREATE_SUCCESS = "PROJECT_CREATE_SUCCESS";
export const PROJECT_CREATE_FAIL = "PROJECT_CREATE_FAIL";
export const PROJECT_REQUEST = "PROJECT_REQUEST";
export const PROJECT_SUCCESS = "PROJECT_SUCCESS";
export const PROJECT_FAIL = "PROJECT_FAIL";
export const PROJECT_GET_REQUEST = "PROJECT_GET_REQUEST";
export const PROJECT_GET_SUCCESS = "PROJECT_GET_SUCCESS";
export const PROJECT_GET_FAIL = "PROJECT_GET_FAIL";
export const PROJECT_UPDATE_REQUEST = "PROJECT_UPDATE_REQUEST";
export const PROJECT_UPDATE_SUCCESS = "PROJECT_UPDATE_SUCCESS";
export const PROJECT_UPDATE_FAIL = "PROJECT_UPDATE_FAIL";
export const PROJECT_DELETE_REQUEST = "PROJECT_DELETE_REQUEST";
export const PROJECT_DELETE_SUCCESS = "PROJECT_DELETE_SUCCESS";
export const PROJECT_DELETE_FAIL = "PROJECT_DELETE_FAIL";
export const ALL_PROJECTS_SUCCESS = "ALL_PROJECTS_SUCCESS";
// Crdit Sheet Reload Action
export const PROJECT_CREDITS_UPDATE_REQUEST = "PROJECT_CREDITS_UPDATE_REQUEST";
export const PROJECT_CREDITS_UPDATE_SUCCESS = "PROJECT_CREDITS_UPDATE_SUCCESS";
export const PROJECT_CREDITS_UPDATE_FAIL = "PROJECT_CREDITS_UPDATE_FAIL";
export const PROJECT_CREDIT_OPTIONS_STATE_UPDATE =
  "PROJECT_CREDIT_OPTIONS_STATE_UPDATE";
export const PROJECT_CREDITS_ITEMS_UPDATE_SUCCESS =
  "PROJECT_CREDITS_ITEMS_UPDATE_SUCCESS";
export const PROJECT_CREDIT_ITEMS_LOGO_STATE =
  "PROJECT_CREDIT_ITEMS_LOGO_STATE";
//default logos
export const DEFAULT_LOGO_SUCCESS = "DEFAULT_LOGO_SUCCESS";
export const PROJECT_LOGO_UPLOAD_SUCCESS = "PROJECT_LOGO_UPLOAD_SUCCESS";
// Project Option Settings
export const OPTION_REQUEST = "OPTION_REQUEST";
export const PROJECT_OPTION_SUCCESS = "PROJECT_OPTION_SUCCESS";
export const CURRENT_BLOCK_UPDATE = "CURRENT_BLOCK_UPDATE";
export const SETTING_OPTION_STATE = "SETTING_OPTION_STATE";
export const FONT_STYLE_UPDATE = "FONT_STYLE_UPDATE";
export const DEFAULT_SETTINGS_REQUEST = "DEFAULT_SETTINGS_REQUEST";
export const DEFAULT_SETTINGS_SUCCESS = "DEFAULT_SETTINGS_SUCCESS";
export const DEFAULT_SETTINGS_FAIL = "DEFAULT_SETTINGS_FAIL";
// Project Fonts Settings
export const PROJECT_FONTSTYLE_UPDATE_SUCCESS =
  "PROJECT_FONTSTYLE_UPDATE_SUCCESS";
export const PROJECT_SETTINGS_UPDATE_SUCCESS =
  "PROJECT_SETTINGS_UPDATE_SUCCESS";
export const UNDO_REDO_SET_STATE = "UNDO_REDO_SET_STATE";
export const PROJECT_RENDER_REQUEST_SUCCESS = "PROJECT_RENDER_REQUEST_SUCCESS";
export const RENDER_DELETE_SUCCESS = "RENDER_DELETE_SUCCESS";
export const RENDER_DELETE_FAIL = "RENDER_DELETE_FAIL";
export const UPDATE_PREVIEW_SCALE = "UPDATE_PREVIEW_SCALE";
export const BLOCK_MOVE = "BLOCK_MOVE";
// Render Export
export const DOWNLOAD_RENDER_REQUEST = "DOWNLOAD_RENDER_REQUEST";
export const DOWNLOAD_RENDER__SUCCESS = "DOWNLOAD_RENDER__SUCCESS";
export const DOWNLOAD_RENDER_FAIL = "DOWNLOAD_RENDER_FAIL";
export const RENDER_DELETE_All_SUCCESS = "RENDER_DELETE_All_SUCCESS";
export const RENDER_DELETE_ALL_FAIL = "RENDER_DELETE_ALL_FAIL";
export const PAYMENT_REQUEST = "PAYMENT_REQUEST";
export const PAYMENT_SUCCESS = "PAYMENT_SUCCESS";
export const PAYMENT_FAIL = "PAYMENT_FAIL";
//common tpyes here request are common for commonReducer
export const COMMON_REQUEST = "COMMON_REQUEST";
export const COMMON_REQUEST_FAIL = "COMMON_REQUEST_FAIL";
//renders plan
export const RENDERS_PLAN_SUCCESS = "RENDERS_PLAN_SUCCESS";
//current plan
export const CURRENT_PLAN_SUCCESS = "CURRENT_PLAN_SUCCESS";
//stripe Payment
export const STRIPE_PAYMENT_SUCCESS = "STRIPE_PAYMENT_SUCCESS";
//cancell subscription
export const SUBSCRIPTION_CANCELL_SUCCESS = "SUBSCRIPTION_CANCELL_SUCCESS";
export const NOTIFICATION_SUCCESS = "NOTIFICATION_SUCCESS";
export const NOTIFICATION_APPEND_SUCCESS = "NOTIFICATION_APPEND_SUCCESS";
export const NOTIFICATION_LOADING = "NOTIFICATION_LOADING";
export const ADD_NOTIFICATION = "ADD_NOTIFICATION";

export const GLOBAL_COLOR_SUCCESS = "GLOBAL_COLOR_SUCCESS";

export const SURVEY_SUCCESS = "SURVEY_SUCCESS";
// User Helpe Page Instruction
export const HELP_PAGE_REQUEST = "HELP_PAGE_REQUEST";
export const HELP_PAGE_SUCCESS = "HELP_PAGE_SUCCESS";
export const HELP_PAGE_FAIL = "HELP_PAGE_FAIL";
export const FETCH_BYID_SUCCESS = "FETCH_BYID_SUCCESS";
export const HELP_PAGE_SEARCH_SUCCESS = "HELP_PAGE_SEARCH_SUCCESS";
export const HELP_PAGE_SEARCH_FAIL = "HELP_PAGE_SEARCH_FAIL";
// ====================================================================================================
// Card Dashboard Project Create / Get / Update / Delete / Rename
export const CARD_PROJECT_CREATE_REQUEST = "CARD_PROJECT_CREATE_REQUEST";
export const CARD_PROJECT_GET_REQUEST = "CARD_PROJECT_GET_REQUEST";
export const CARD_PROJECT_UPDATE_REQUEST = "CARD_PROJECT_UPDATE_REQUEST";
export const CARD_PROJECT_DELETE_REQUEST = "CARD_PROJECT_DELETE_REQUEST";
export const CARD_PROJECT_SUCCESS = "CARD_PROJECT_SUCCESS";
export const CARD_PROJECT_FAIL = "CARD_PROJECT_FAIL";
// For Card Layout Navbar  Sync/Reload (Credit Sheet) ===============================================================
export const CARD_PROJECT_CREDITS_UPDATE_REQUEST =
  "CARD_PROJECT_CREDITS_UPDATE_REQUEST";
export const CARD_PROJECT_CREDITS_UPDATE_SUCCESS =
  "CARD_PROJECT_CREDITS_UPDATE_SUCCESS";
// For Layout Options State ==========================================================================
export const CARD_OPTIONS_UPDATE_REQUEST = "CARD_OPTIONS_UPDATE_REQUEST";
export const CARD_OPTIONS_UPDATE_SUCCESS = "CARD_OPTIONS_UPDATE_SUCCESS";
export const CARD_OPTIONS_UPDATE_FAIL = "CARD_OPTIONS_UPDATE_FAIL";
export const CARD_OPTION_SELECT_TYPE_REQUEST =
  "CARD_OPTION_SELECT_TYPE_REQUEST";
export const CARD_OPTION_SELECT_TYPE_SUCCESS =
  "CARD_OPTION_SELECT_TYPE_SUCCESS";
export const CARD_OPTIONS_CREDIT_UPDATE_SUCCESS = "CARD_OPTIONS_UPDATE_SUCCESS";
// Undo / Redo
export const CARD_OPTIONS_UNDO_REQUEST = "CARD_OPTIONS_UNDO_REQUEST";
export const CARD_OPTIONS_UNDO_SUCCESS = "CARD_OPTIONS_UNDO_SUCCESS";
export const CARD_OPTIONS_UNDO_FAIL = "CARD_OPTIONS_UNDO_FAIL";
export const CARD_OPTIONS_REDO_REQUEST = "CARD_OPTIONS_REDO_REQUEST";
export const CARD_OPTIONS_REDO_SUCCESS = "CARD_OPTIONS_REDO_SUCCESS";
export const CARD_OPTIONS_REDO_FAIL = "CARD_OPTIONS_REDO_FAIL";
// Sidebar ===========================================================================================
export const CARD_CURRENT_BLOCK_SELECT_REQUEST =
  "CARD_CURRENT_BLOCK_SELECT_REQUEST";
export const CARD_CURRENT_BLOCK_SELECT_SUCCESS =
  "CARD_CURRENT_BLOCK_SELECT_SUCCESS";
// For Layout Font State==============================================================================
export const CARD_FONT_UPDATE_REQUEST = "CARD_FONT_UPDATE_REQUEST";
export const CARD_FONT_UPDATE_SUCCESS = "CARD_FONT_UPDATE_SUCCESS";
export const CARD_FONT_UPDATE_FAIL = "CARD_FONT_UPDATE_FAIL";
export const CARD_FONT_SAVE_REQUEST = "CARD_FONT_SAVE_REQUEST";
export const CARD_FONT_SAVE_SUCCESS = "CARD_FONT_SAVE_SUCCESS";
export const CARD_FONT_SAVE_FAIL = "CARD_FONT_SAVE_FAIL";
// For Render Setting State ==========================================================================
export const CARD_PROJECT_SETTINGS_UPDATE_REQUEST =
  "CARD_PROJECT_SETTINGS_UPDATE_REQUEST";
export const CARD_PROJECT_SETTINGS_UPDATE_SUCCESS =
  "CARD_PROJECT_SETTINGS_UPDATE_SUCCESS";
// Render Table
export const CARD_RENDER_REQUEST = "CARD_RENDER_REQUEST";
export const CARD_RENDER_SUCCESS = "CARD_RENDER_SUCCESS";
export const CARD_RENDER_FAIL = "CARD_RENDER_FAIL";
// Download
export const CARD_RENDER_DOWNLOAD_REQUEST = "CARD_RENDER_DOWNLOAD_REQUEST";
export const CARD_RENDER_DOWNLOAD_SUCCESS = "CARD_RENDER_DOWNLOAD_SUCCESS";
export const CARD_RENDER_DOWNLOAD_FAIL = "CARD_RENDER_DOWNLOAD_FAIL";
// Delete
export const CARD_RENDER_DELETE_SUCCESS = "CARD_RENDER_DELETE_SUCCESS";
export const CARD_RENDER_DELETE_FAIL = "CARD_RENDER_DELETE_FAIL";
export const CARD_RENDER_ALL_DELETE_SUCCESS = "CARD_RENDER_ALL_DELETE_SUCCESS";
export const CARD_RENDER_ALL_DELETE_FAIL = "CARD_RENDER_ALL_DELETE_FAIL";
export const PROJECT_SCROLL_GLOBAL_OPTION_SUCCESS = "PROJECT_SCROLL_GLOBAL_OPTION_SUCCESS";
// Resolution Update ======================================================================
export const RESOLUTION_VALUE_UPDATE_SUCCESS =
  "RESOLUTION_VALUE_UPDATE_SUCCESS";
// Global screen options
export const PROJECT_GLOBAL_OPTION_SUCCESS = "PROJECT_GLOBAL_OPTION_SUCCESS";
export const UPDATE_USER_RENDER_CNT = "UPDATE_USER_RENDER_CNT";
export const UPDATE_USER_RENDER_CNT_FAIL = "UPDATE_USER_RENDER_CNT_FAIL";
export const INCREASE_RENDER_CNT = "INCREASE_RENDER_CNT";
// STRIPE DATA ===============================================================================
export const USER_STRIPE_DATA_SUCCESS = "USER_STRIPE_DATA_SUCCESS";
export const USER_STRIPE_DATA_FAIL = "USER_STRIPE_DATA_FAIL";

export const PLAN_SELECT_REQUEST = "PLAN_SELECT_REQUEST";
export const PLAN_SELECT_SUCCESS = "PLAN_SELECT_SUCCESS";

// Page Select Types for Route identify ======================================================
export const PAGE_SELECT_REQUEST = "PAGE_SELECT_REQUEST";
export const PAGE_SELECT_SUCCESS = "PAGE_SELECT_SUCCESS";

export const USER_FETCH_SUCCESS = "USER_FETCH_SUCCESS";
export const USER_FETCH_FAIL = "USER_FETCH_FAIL";

//===============================================================
export const FIRST_TIME_RENDER_AFTER_PLAN_SUCCESS = "FIRST_TIME_RENDER_AFTER_PLAN_SUCCESS";

export const CUSTOM_FONTS_LOAD_SUCCESS = "CUSTOM_FONTS_LOAD_SUCCESS";

